/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import DashboardShell from "../../dashboard/DashboardShell";
import { useDashboardLevelContext } from "../../../context/levels";
import { getCityDashboard } from "../../../lib/sysNavigation/SysNavigation";

const LEVEL_FIELD = {
  First: "first_level_id",
  Second: "second_level_id",
  Third: "third_level_id",
  Fourth: "fourth_level_id",
};

const DashboardCity = () => {
  const [city_level, data] = getCityDashboard();
  const { statsLevel, fetchLevelData } = useDashboardLevelContext();

  const level_id = data?.[LEVEL_FIELD[city_level]] ?? null;
  const cityName = data?.name ?? "City";

  useEffect(() => {
    if (level_id) fetchLevelData(level_id, city_level);
  }, [level_id, city_level]);

  return (
    <DashboardShell
      title={cityName}
      subtitle={`${city_level} level · content footprint`}
      stats={statsLevel}
      clickRoute="/cities"
      showTableStats={false}
      hideGeography
      breadCrumbDefault={false}
    />
  );
};

export default DashboardCity;
